<template>
  <div class="main bg-white launch-product">
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="推新Banner配置" name="banner">
        <banner-config v-if="activeTab === 'banner'" />
      </el-tab-pane>
      <el-tab-pane label="推新集合配置" name="collection">
        <collection-config v-if="activeTab === 'collection'" />
      </el-tab-pane>
      <el-tab-pane label="推新用户访问数据" name="visit">
        <visit-data v-if="activeTab === 'visit'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BannerConfig from './components/BannerConfig.vue'
import CollectionConfig from './components/CollectionConfig.vue'
import VisitData from './components/VisitData.vue'

export default {
  name: 'launchProduct',
  components: {
    BannerConfig,
    CollectionConfig,
    VisitData
  },
  data() {
    return {
      activeTab: 'banner'
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding: 20px;
  min-height: calc(100vh - 64px);
}
.launch-product {
  max-width: unset !important;
  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
}
</style>
